import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { setMiniSidenav, useMaterialUIController } from "./context";
import { useEffect, useState } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./assest/theme";
import Sidenav from "./layoutcontainers/DashboardLayout/components/Sidebar";
import routes from "./routes";
import logo from "../src/assest/images/logo.png";
import "./css/app.css";
import LodingCirlce from "./components/Loading/Loding";
import { useLoading } from "./context/LodingContext";
import SignIn from "./meefood/pages/authentication/signin/SignIn";
import EmailForgotInput from "./meefood/pages/authentication/forgot/EmailForgot";
import SetPassword from "./meefood/pages/authentication/setPassword/SetPassword";
import { useAuthData } from "./meefood/context/loginContext/LoginContextProvider";
import Page from "./meefood/pages/privacyPolicy/pages";

function App() {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, direction, layout, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();

  const { authenticated, access } = useAuthData();
  const { circleLoading } = useLoading();

  const filteredRoutes = routes.filter((route) => {
    // Always allow routes with access: "all"
    // if (route.access === "admin") {
    //   return true;
    // }

    // Otherwise, check module-based access control
    const accessEntry = access?.find(
      (entry) =>
        entry?.module === route?.module &&
        route?.protected === entry?.can_access
    );
    return !!accessEntry;
  });

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.route) {
        return (
          <>
            {authenticated && (
              <Route
                exact
                path={route.route}
                element={route.component}
                key={route.key}
              />
            )}
          </>
        );
      }

      return null;
    });
    
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      {layout === "dashboard" && pathname !== "/privacy-policy" && (
        <>  
          <Sidenav
            color={sidenavColor}
            brand={logo}
            brandName="Keelis"
            routes={filteredRoutes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
        </>
      )}
      {circleLoading && (
        <div style={{ position: "fixed", inset: 0, zIndex: "1000000000000" }}>
          <LodingCirlce pending={circleLoading} />
        </div>
      )}

      <Routes>
        {getRoutes(filteredRoutes)}

        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/privacy-policy" element={<Page />} />
        <Route path="/sign-in/forgotemail" element={<EmailForgotInput />} />

        <Route path="/set-password/:uid/:token/" element={<SetPassword />} />
        <Route path="/createpassword/:uid/:token/" element={<SetPassword />} />

        <Route
          path="*"
          element={<Navigate to={authenticated ? "/dashboard" : "/sign-in"} />}
        />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
